import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import { ClassProp } from 'helpers/types';
import {
  Offer,
  OfferStatus,
} from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.types';

import styles from '../../OffersTable.styles';

type Props = {
  classes: ClassProp<ReturnType<typeof styles>>;
  fieldValue: string;
  record?: Record<string, any>;
  options?: Record<string, any>;
};

const StatusPill: FunctionComponent<Props> = ({ classes, record }) => {
  const offer = record as Offer;

  const classNames = classnames(classes.statusPill, {
    [classes.isOfferLive]: offer.offerStatus === OfferStatus.Active,
    [classes.isOfferComplete]: offer.offerStatus === OfferStatus.Completed,
    [classes.isOfferNew]: offer.offerStatus === OfferStatus.Future,
  });

  return (
    <div className={classNames}>
      <span>{OfferStatus[offer.offerStatus]}</span>
    </div>
  );
};

export default StatusPill;
